import type { ReactNode } from 'react';

export const directoryTooltipContentClassName =
  '!pointer-events-auto !max-w-[420px] !whitespace-normal !rounded-xl !border !border-[#E8EBF3] !bg-white !p-0 !text-left !leading-5 !text-[#1A162F] !shadow-[0_12px_32px_rgba(26,22,47,0.12)]';

const DirectoryTooltipContent = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => (
  <div onClick={(event) => event.stopPropagation()} className="space-y-2 py-3">
    <p className="px-3.5 text-xs font-semibold text-[#1A162F]">{title}</p>
    <ol
      aria-label={title}
      className="integrations-apps-scroll-area max-h-[240px] space-y-2 overflow-y-auto overscroll-contain pl-3.5 pr-2.5"
    >
      {children}
    </ol>
  </div>
);

export default DirectoryTooltipContent;
